<template>
  <v-container id="sign-in" pa-0>
    <v-layout id="login-container" column fill-height>
      <v-flex/>
      <v-flex id="fdi-logo">
        <v-flex d-flex justify-center align-center>
          <v-avatar :size="mainLogoSize">
            <img :src="FDILogo" alt="Fooddoneit">
          </v-avatar>
        </v-flex>
      </v-flex>

      <v-flex d-flex align-center>
        <v-layout id="fdi-login-form" column justify-center>
          <v-flex xs12 d-flex justify-center align-center>
            <v-flex xs6 md4>
              <v-text-field
                @keyup.enter.stop.prevent
                v-model="username"
                hide-details
                single-line
                label="username"
                name="username"
                id="username"
              ></v-text-field>
              <v-text-field
                @keyup.enter.stop.prevent
                v-model="password"
                hide-details
                single-line
                name="password"
                label="PASSWORD"
                id="password"
              ></v-text-field>
            </v-flex>
          </v-flex>

          <v-flex xs12 d-flex justify-center align-center>
            <v-flex xs12 sm6 md4>
              <v-alert color="#AE250A" my-0 py-0 v-if="error" value="error" type="error">{{ error }}</v-alert>
              <div id="error-spacer" v-else></div>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-flex d-flex align-center>
          <v-avatar :size="mainLoginButtonSize" @click="signIn">
            <img :src="loginBtnSrc">
          </v-avatar>
        </v-flex>

        <v-flex id="reset-pw-btn" mt-3 xs12 d-flex align-center justify-center>
          <v-flex xs3 d-flex align-center justify-center>
            <!-- <v-btn color="#AE250A" small v-on:click="forgot">
              <span>RESET Password</span>
            </v-btn>-->
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Auth, Logger, JS } from "aws-amplify";
import AmplifyStore from "@/store";
import FDILogo from "@/assets/logo_login_blk.png";
import loginBtnSrc from "@/assets/login_blk.png";
import backgroundImage from "../../../assets/backgrounds/login-bkgd.png";

const logger = new Logger("SignInComp");
export default {
  name: "SignIn",
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      user: null,
      confirmView: false,
      signUpView: false,
      code: "",
      activeTab: "",
      error: null,
      FDILogo,
      loginBtnSrc,
      backgroundImage: backgroundImage,
      alert: true
    };
  },
  computed: {
    mainLogoSize() {
      let height = this.$store.getters.appInnerHeight;
      //console.log(height)
      if (height < 600) {
        return 200;
      } else if (height > 600 && height < 800) {
        return 250;
      } else if (height > 800) {
        return 250;
      }
    },
    mainLoginButtonSize() {
      let height = this.$store.getters.appInnerHeight;
      if (height < 600) {
        return 80;
      } else if (height > 600 && height < 700) {
        return 80;
      } else if (height > 700) {
        return 80;
      }
    }
  },
  methods: {
    signIn: function(event) {
      const that = this;

      this.$store.commit("setTempUser", {
        username: this.username,
        password: this.password
      });
      Auth.signIn(this.username, this.password)
        .then(user => {
          logger.debug("sign in success", user);
          return user;
        })
        .then(user => {
          that.user = user;
          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            this.$store.dispatch("setTempCognitoUser", user);
            this.$router.push("/auth/changePassword");
          } else {
            that.$router.replace("/", res => {
              window.location.reload();
            });
          }
        })
        .catch(err => {
          this.$store.dispatch("setUser", null);
          if (err.code === "UserNotConfirmedException") {
            Auth.resendSignUp(this.username)
              .then(() => {
                logger.debug("code resent");
                this.$router.push("/auth/confirmSignUp");
                return;
              })
              .catch(err => this.setError(err));
          } else {
            return this.setError(err);
          }
        });
    },
    checkUser: function() {
      const user = this.user;
      if (!user) {
        return;
      }
      Auth.verifiedContact(user)
        .then(data => {
          logger.debug("verify result", data);
          this.$store.commit("setUserVerification", data);
          if (!JS.isEmpty(data.verified)) {
            this.$router.push("/");
          } else {
            this.$router.push("/auth/verifyContact");
          }
        })
        .catch(err => console.log(err));
    },
    confirm: function() {
      Auth.confirmSignIn(this.user, this.code)
        .then(() => {
          this.$router.push("/");
        })
        .catch(err => this.setError(err));
    },
    forgot: function() {
      this.$router.push("/auth/forgotPassword");
    },
    signUp: function() {
      AmplifyStore.commit("setTempUserName", this.username);
      AmplifyStore.commit("setTempUserPassword", this.password);
      AmplifyStore.commit("setTempUser", {
        username: this.username,
        password: this.password
      });
      Auth.signUp(this.username, this.password)
        .then(data => {
          logger.debug("sign up success", data);
          this.$router.push("/auth/confirmSignUp");
        })
        .catch(err => {
          if (err.code == "UsernameExistsException") {
            this.toggleForm("login");
            this.setError(`${err.message}\nTry logging in now`);
            return;
          }
          logger.error("sign up error", err);
          this.setError(err);
        });
    },
    setError: function(err) {
      this.error = err.message || err;
    },
    setSignUp: function() {
      this.signUpView = true;
    },
    toggleForm: function(val) {
      this.signUpView = val === "signup";
    },
    getColor: function() {
      return this.signUpView ? "orange darken-1" : "orange lighten-3";
    }
  }
};
</script>

<style scoped>
#fdi-logo {
  margin-top: 20px;
}
</style>

<style>
#sign-in {
  height: 100%;
  background-color: Transparent;
  font-family: "PrestigeElite-STD";
}

#reset-pw-btn {
  font-family: "BebasNeue-Regular";
}

#login-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

#error-spacer {
  height: 66px;
}

#alerty {
  position: absolute;
  bottom: 0;
  width: 100%;
}

#bottom-button-container {
  height: 44px;
}

#fdi-login-form .v-text-field__slot label {
  text-align: center;
  width: 100%;
  color: #ae250a;
  font-size: 18px;
  margin-left: 10px;
  margin-right: 10px;
  font-family: "BebasNeue-Regular";
}

#fdi-login-form .v-input .v-label--active {
}

#fdi-login-form .v-text-field__slot input {
  border-bottom: 2px solid black;
  padding-bottom: 2px;
  letter-spacing: 1.5px;
  text-align: center;
  font-size: 14px;
}

#fdi-login-form .v-text-field__slot input:active {
}

#login-footer {
  justify-content: "flex-end";
}
</style>
